import { useId } from 'react'
import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const LogoIconAtom = (props: SvgIconProps) => {
	// Varaibles
	const id = useId()
	const radius = 325

	return (
		<SvgIcon {...props} viewBox="0 0 1000 1000">
			<defs>
				<mask id={id}>
					<path
						fill="#fff"
						d={`M 0 ${radius}
							Q ${radius / 10} ${radius / 10} ${radius} 0
							L ${1000 - radius} 0
							Q ${1000 - radius / 10} ${radius / 10} 1000 ${radius}
							L 1000 ${1000 - radius}
							Q ${1000 - radius / 10} ${1000 - radius / 10} ${1000 - radius} 1000
							L ${radius} 1000
							Q ${radius / 10} ${1000 - radius / 10} 0 ${1000 - radius}
							L 0 ${radius}
							Z`}
					/>
				</mask>
			</defs>

			<path
				mask={`url(#${id})`}
				fill="currentColor"
				d="M 0 0 L 0 1000 1000 1000 1000 0 0 0 M 700 100 L 699.95 270 270 270 270 439.95 100 440 100 265.65 Q 101.55 198.1 149.9 149.9 198.1 101.55 265.65 100 L 700 100 M 730 300 L 900 300 900 734.4 Q 898.45 801.95 850.15 850.15 801.95 898.45 734.4 900 L 730 900 730 300 Z"
			/>
		</SvgIcon>
	)
}

export default LogoIconAtom
